class Notify {
  constructor(options) {
    Object.assign(this, options)
  }
}

export default Notify;
